import {
    FeatureFlags,
    FeatureFlagActions,
    SET_ENABLED_FEATURES,
    EnabledFeature,
    FeaturesList,
} from './types';
import { Reducer } from 'redux';

export const initialState: FeatureFlags = {
    isLoading: true,
    features: {},
};

const FeatureFlagging: Reducer<FeatureFlags, FeatureFlagActions> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case SET_ENABLED_FEATURES:
            return {
                isLoading: false,
                features: action.enabledFeatures.reduce(
                    (acc: FeaturesList, value: EnabledFeature) => {
                        acc[value.label] = value.isEnabled;
                        return acc;
                    },
                    {},
                ),
            };
        default:
            return state;
    }
};

export default FeatureFlagging;
